var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import CommentInput from './CommentInput';
import CommentList from './CommentList';
import { HiChevronDoubleDown } from 'react-icons/hi';
import { uuidv4 } from '../../common/utils';
import ProgressBar from '../ProgressBar/ProgressBar';
/**
 *
 * @props id: Name to be added to Sidebar
 * @props commentList: List of Comment
 * @commentList description: Description of your comment
 * @commentList nickname: Nickname to display
 * @commentList date: Day when comment written
 * @props theme: Theme of Visitor Comment Component (default: basic) "basic" | "box" | "vertical"
 * @props backgroundColor: Background color of area that out of comment list component (default: whitesmoke)
 * @props buttonColor: Text color of Send Button (default: #1877f2)
 * @props commentInputPlacehoder: Placeholder of inputs description, nickname and password
 * @props inputBackgroundColor: Background color of input area (default: white)
 * @props inputFontColor: Font Color in input box when create comment, user infomation (default: black)
 * @props inputPlacehoderColor: Placehoder font Color in input comment, user infomation boxes (default: black)
 * @props userInputLineColor: Color of bottom border used in nickname and password area (defualt: #b4b4b4a2)
 * @props listBackgroundColor: Background color of comment list (default: white)
 * @props listCommentColor: Color of comment in comment list (default: black)
 * @props listNicknameColor: Color of nickname in comment list (default: #959595)
 * @props listDateColor: Color of date in comment list (default: #959595)
 * @props progressbarColor: Color of progressbar appearing when if comment list overflowed comment area (default: #5f5f5f)
 * @props isShowScrollDownIcon: Flag wheter show scroll down icon (default: true)
 * @props scrollDownIconColor: Color of scroll down icon (default: black)
 * @commentInputPlacehoder desPlaceholder: Placeholder of description area (default: 'write your description...')
 * @commentInputPlacehoder nicknamePlaceholder: Placeholder of nickname area (default: 'ID')
 * @commentInputPlacehoder passwordPlaceholder: Placeholder of password area (default: 'PW')
 */
var VisitorComment = function (props) {
    var id = props.id, commentList = props.commentList, theme = props.theme, backgroundColor = props.backgroundColor, buttonColor = props.buttonColor, descriptionPlaceholder = props.descriptionPlaceholder, nicknamePlaceholder = props.nicknamePlaceholder, passwordPlaceholder = props.passwordPlaceholder, inputBackgroundColor = props.inputBackgroundColor, userInputLineColor = props.userInputLineColor, progressbarColor = props.progressbarColor, isShowScrollDownIcon = props.isShowScrollDownIcon, scrollDownIconColor = props.scrollDownIconColor, comment = props.comment, nickname = props.nickname, password = props.password, handleCreateComment = props.handleCreateComment, handleChangeDescription = props.handleChangeDescription, handleChangeNickname = props.handleChangeNickname, handleChangePassword = props.handleChangePassword, listBackgroundColor = props.listBackgroundColor, listCommentColor = props.listCommentColor, inputFontColor = props.inputFontColor, inputPlacehoderColor = props.inputPlacehoderColor, listNicknameColor = props.listNicknameColor, listDateColor = props.listDateColor;
    //make progressbar in commentList scroll-y
    var _a = useState(0), rate = _a[0], setRate = _a[1];
    var _b = useState(false), isOverflow = _b[0], setIsOverflow = _b[1];
    var ref = useRef(null);
    useEffect(function () {
        var element = ref.current;
        if (element) {
            var isOverflow_1 = element.scrollHeight > element.clientHeight;
            setIsOverflow(isOverflow_1);
        }
    }, []);
    var scrollHandler = function (event) {
        var containerHeight = event.currentTarget.clientHeight;
        var scrollHeight = event.currentTarget.scrollHeight;
        var scrollTop = event.currentTarget.scrollTop;
        var result = (scrollTop / (containerHeight - scrollHeight)) * -100;
        setRate(result);
    };
    return (_jsxs(Wrap, __assign({ id: id, backgroundColor: backgroundColor, scrollDownIconColor: scrollDownIconColor }, { children: [isShowScrollDownIcon && isOverflow && _jsx(HiChevronDoubleDown, {}), _jsx(CommentInput, { theme: theme, buttonColor: buttonColor, descriptionPlaceholder: descriptionPlaceholder, nicknamePlaceholder: nicknamePlaceholder, passwordPlaceholder: passwordPlaceholder, inputBackgroundColor: inputBackgroundColor, userInputLineColor: userInputLineColor, handleCreateComment: handleCreateComment, handleChangeDescription: handleChangeDescription, handleChangeNickname: handleChangeNickname, handleChangePassword: handleChangePassword, comment: comment, nickname: nickname, password: password, inputFontColor: inputFontColor, inputPlacehoderColor: inputPlacehoderColor }), isOverflow && (_jsx(ProgressBar, { isHiddenRateText: true, rateText: "".concat(rate, "%"), height: "3px", colorFrom: progressbarColor, colorTo: progressbarColor, animationType: "none" })), _jsx(ChildWrap, __assign({ ref: ref, onScroll: scrollHandler, theme: theme, listCommentColor: listCommentColor }, { children: commentList === null || commentList === void 0 ? void 0 : commentList.slice(0).reverse().map(function (elements) { return (_jsx(CommentList, __assign({}, elements, { theme: theme, listBackgroundColor: listBackgroundColor, listNicknameColor: listNicknameColor, listDateColor: listDateColor }), uuidv4())); }) }))] })));
};
export default VisitorComment;
VisitorComment.defaultProps = {
    theme: 'basic',
    progressbarColor: '#5f5f5f',
    isShowScrollDownIcon: true,
    commentList: [
        {
            description: "The scroll customization method is the same as the teckstack component progress bar, so please use it!",
            nickname: 'woorim960',
            date: '2022-08-26',
        },
        {
            description: "Progress bar customization is also possible when creating a scroll.",
            nickname: 'seohyunsim',
            date: '2022-08-26',
        },
        {
            description: "Likewise, there are three types of themes: basic, box, and vertical.",
            nickname: 'jisu3817',
            date: '2022-08-26',
        },
        {
            description: 'Refer to dev-portfolio README.md for instructions on building a personal server.',
            nickname: 'soonki-98',
            date: '2022-08-26',
        },
        {
            description: "A personal server can be built through environmental variables, and visitors can write their text and nicknames.",
            nickname: 'woorim960',
            date: '2022-08-26',
        },
        {
            description: 'By looking at your portfolio, visitors can leave a guest book.',
            nickname: 'seohyunsim',
            date: '2022-08-26',
        },
    ],
};
var Wrap = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  padding: 1em 5em;\n  padding-top: 0;\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 500px) {\n    padding: 1em 5vw;\n  }\n  svg {\n    position: absolute;\n    bottom: 1.7em;\n    left: 49.5%;\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  padding: 1em 5em;\n  padding-top: 0;\n  display: flex;\n  flex-direction: column;\n  @media screen and (max-width: 500px) {\n    padding: 1em 5vw;\n  }\n  svg {\n    position: absolute;\n    bottom: 1.7em;\n    left: 49.5%;\n    color: ", ";\n  }\n"])), function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : 'whitesmoke';
}, function (_a) {
    var scrollDownIconColor = _a.scrollDownIconColor;
    return scrollDownIconColor !== null && scrollDownIconColor !== void 0 ? scrollDownIconColor : 'black';
});
var ChildWrap = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  margin-top: 3px;\n  height: ", ";\n  overflow-y: scroll;\n  background-color: ", ";\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  border-bottom: 0px;\n  display: flex;\n  white-space: pre-wrap;\n  border: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"], ["\n  color: ", ";\n  margin-top: 3px;\n  height: ", ";\n  overflow-y: scroll;\n  background-color: ", ";\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  border-bottom: 0px;\n  display: flex;\n  white-space: pre-wrap;\n  border: ", ";\n  flex-direction: ", ";\n  flex-wrap: ", ";\n  justify-content: ", ";\n"])), function (_a) {
    var listCommentColor = _a.listCommentColor;
    return listCommentColor !== null && listCommentColor !== void 0 ? listCommentColor : 'black';
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'vertical' ? '580px' : '400px');
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'basic' ? 'white' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'basic' ? '0.2px solid #b4b4b4a0' : 'none');
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'vertical' ? 'row' : 'column');
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'vertical' ? 'wrap' : 'nowrap');
}, function (_a) {
    var theme = _a.theme;
    return (theme === 'vertical' ? 'space-around' : 'none');
});
var templateObject_1, templateObject_2;
